/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: src/components/Home.tsx
*/

import React from 'react';

import {
  OfferingSection,
  SlideSection,
  ClientListSection,
  TestimonialsSection,
  FooterSection,
} from './HomePage.css';
import OfferingContent from './OfferingContent';
import { useRecoilState } from 'recoil';
import { userState } from '../../../recoil/atoms/userAtoms';
import BooksContent from './BooksContent';
import ClientListContent from './ClientListContent';
import colors from '../../../styles/colors';
import Testimonials from '../../ui/Testimonials/Testimonials';
import Footer from './Footer';

export default function HomePage() {
  const [user] = useRecoilState(userState);
  return (
    <>
      <OfferingSection
        id="offering-section"
        isLightsOn={user.isLightsOn}
        colorDay={colors.easyGreenBackground}
        colorNight={colors.lightGrey}
      >
        <OfferingContent isLightsOn={user.isLightsOn} initialPause={false} />
      </OfferingSection>

      <SlideSection
        id="slide-section"
        isLightsOn={user.isLightsOn}
        colorDay={colors.white}
        colorNight={colors.lightGrey}
      >
        <BooksContent
          isLightsOn={user.isLightsOn}
          colorDay={colors.white}
          colorNight={colors.lightGrey}
        />
      </SlideSection>

      <ClientListSection
        id="client-list-section"
        isLightsOn={user.isLightsOn}
        colorDay={colors.white}
        colorNight={colors.lightGrey}
      >
        <ClientListContent isLightsOn={user.isLightsOn} />
      </ClientListSection>

      <TestimonialsSection
        id="testimonials-section"
        isLightsOn={user.isLightsOn}
        colorDay={colors.softMatBrown}
        colorNight={colors.lightGrey}
      >
        <Testimonials />
      </TestimonialsSection>

      <FooterSection
        id="footer-section"
        isLightsOn={user.isLightsOn}
        colorDay={colors.backgroundGrey}
        colorNight={colors.lightGrey}
      >
        <Footer
          isLightsOn={user.isLightsOn}
          colorDay={colors.white}
          colorNight={colors.lightGrey}
        />
      </FooterSection>
    </>
  );
}
